import { render } from "./DocPOS.vue?vue&type=template&id=7bda7354&scoped=true&ts=true"
import script from "./DocPOS.vue?vue&type=script&lang=ts"
export * from "./DocPOS.vue?vue&type=script&lang=ts"

import "./DocPOS.vue?vue&type=style&index=0&id=7bda7354&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bda7354"]])

export default __exports__